export default __webpack_public_path__ + "7ce6760d17685c466ba04d1b2c63c38b.ttf";